import { useDashboardColor } from "../../context/DashboardColorContext";
import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricStatValue from "../charts/MetricStatValue";
import GradientBar from "../GradientBar";
import MetricCard from "../MetricCard";
import SoloIcon from "../SoloIcon";

const EducationMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag }: MetricPanelProps) => {   
    const color = useDashboardColor();

    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Education data:", sortedMetrics);

    const e = sortedMetrics[0];
    const hs = indicators.find((i: any) => i.id === 1098);
    const nohs = indicators.find((i: any) => i.id === 1104);
    const bach = indicators.find((i: any) => i.id === 1101);

    return (
        <div className="h-screen">
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 gap-4">
                {e.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}   
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}
                <div className="col-span-1 xxs:col-span-2 w-full">
                    <div 
                        className="relative overflow-hidden group hover:shadow-md transition-all border rounded-xl bg-white" 
                    >
                        <div className="bg-white p-3">
                            <h3 className="text-sm font-semibold text-color-cai-brown">
                                Educational Attainment
                            </h3>
                            
                            <div className="grid grid-cols-3 gap-4">
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1104}
                                            id={1104}
                                            unit={nohs?.versions[0].unit}
                                            title={nohs?.name ?? "Age 25+ without HS Diploma/GED"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={nohs}/>
                                </div> 
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1098}
                                            id={1098}
                                            unit={hs?.versions[0].unit}
                                            title={hs?.name ?? "Age 25+ with HS Diploma/GED"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={hs}/>
                                </div> 
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1101}
                                            id={1101}
                                            unit={bach?.versions[0].unit}
                                            title={bach?.name ?? "Age 25+ with a Bachelor's Degree+"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={bach}/>
                                </div>
                            </div>
                        </div>
                        <GradientBar color={color} />
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}

export default EducationMetrics;